import { useRouteQuery } from '@/common/route/useRouteQuery';
import { color } from '@/common/utils/helpers';
import { StringUtils } from '@/common/utils/stringUtils';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useRfmGroupList } from '@/modules/rfm/group/model/list';
import { rfmService } from '@/services/rfm';
import { computed } from 'vue';

export function useRfmPersonaList() {
    const crudAction = useCrudActions();

    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            groupId: { type: 'number', default: null }
        },
        onChange: () => fetchList()
    });

    const { rfmGroupOptions, rfmGroupNameMap, fetchRfmGroupAll } = useRfmGroupList();

    const { list, total, fetchList } = useBaseListView({
        request: rfmService.persona.list,
        paramsBuilder: () => query,
        hooks: {
            loadInitialData: async () => await fetchRfmGroupAll(),
            onSuccess: updateQueryToRoute,
            canFetch: () => query.groupId !== null,
            transformResponse: (list: any[]) =>
                list.map((item: any) => ({
                    ...item,
                    groupName: rfmGroupNameMap.value.get(item.groupId) || StringUtils.Characters.Empty,
                    nameWithColor: `<font color="${color(item.id)}"><i class="fas fa-bookmark"></i></font> ${item.name}`
                }))
        }
    });

    const { list: personaAll, fetchList: fetchPersonaAll } = useBaseListView({ request: rfmService.persona.list });
    const personaMap = computed(() => new Map(personaAll.value.map(item => [item.id, item])));
    const personaOptions = computed(() => {
        return personaAll.value.map(item => ({ value: item.id, label: item.name, groupId: item.groupId }));
    });

    const actions = {
        remove: crudAction.confirmAndRemove({
            request: rfmService.persona.remove,
            onSuccess: () => fetchList()
        })
    };

    return {
        list,
        total,
        fetchList,
        query,
        rfmGroupOptions,
        personaOptions,
        fetchPersonaAll,
        personaAll,
        personaMap,
        actions
    };
}
